var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".refresh-svg{fill:#ffffff;}")),React.createElement("path",{"className":"refresh-svg","d":"M13.08,6.63V1.39L10.83,3.65a6.1,6.1,0,1,0,1,6l-1.56-.89A4.36,4.36,0,1,1,9.58,4.9L7.85,6.63Z","key":1})]);
}

Refresh.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 15 15","width":"15","height":"15"};

module.exports = Refresh;

Refresh.default = Refresh;
